import { debounce } from 'lodash-es';

import { GuidService } from 'ui-components/services/guid-service';

import { buildGroupTraits, buildIdentifyTraits, isImpersonating } from './analytics-utility';
import { getDisplayInformation } from './display-info-service';

const WINDOW_RESIZE = 'WINDOW_RESIZE';
const DEVELOPMENT_ENVIRONMENT = 'dev';

// oxlint-disable-next-line no-console
const consoleInfo = console.info.bind(console);

const environment = window.SS_GLOBALS.environment || DEVELOPMENT_ENVIRONMENT;
const isInDevelopmentMode = environment === DEVELOPMENT_ENVIRONMENT;
const appSessionGuid = GuidService.newGuid();

class SegmentClass {
  identifyUser(userId, sellerId, userInfo, sellerInfo) {
    if (!window.analytics || isImpersonating()) {
      return;
    }

    window.analytics.identify(userId, {
      ...buildIdentifyTraits(sellerId, userInfo, sellerInfo),
      ...getDisplayInformation(),
    });
    window.analytics.group(sellerId, buildGroupTraits(sellerId, sellerInfo));

    const metadata = {
      sellerId,
    };
    const trackResize = this.trackResize.bind(this);
    window.onresize = debounce(() => trackResize(metadata), 3000);
  }

  trackPage(pageName, metadata = {}) {
    if (!window.analytics || isImpersonating()) {
      return;
    }
    const trackingParams = {
      groupId: metadata.sellerId,
      appSessionGuid,
      ...getDisplayInformation(),
    };

    window.analytics.page(pageName, trackingParams);
  }

  trackEvent(actionName, params, metadata = {}) {
    if (isInDevelopmentMode) {
      consoleInfo(actionName, params, metadata, appSessionGuid);
    }

    if (!window.analytics || isImpersonating()) {
      return;
    }
    const trackParams = {
      groupdId: metadata?.sellerId,
      type: actionName,
      appSessionGuid,
      ...params,
    };

    window.analytics.track(actionName, trackParams);
  }

  trackResize(metadata) {
    this.trackEvent(WINDOW_RESIZE, getDisplayInformation(), metadata);
  }
}

export const Segment = new SegmentClass();
